/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState, useEffect, useRef } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Waypoint } from 'react-waypoint'
import { Canvas } from 'components/canvas'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Calendar } from 'components/calendar'
import { Counter } from 'components/counter'
// import { Chart } from 'components/chart'
// import { Controller, Scene } from 'react-scrollmagic'
// import { Tween, Timeline } from 'react-gsap'
import texts from './texts.yml'
// import { csv } from 'd3-fetch'

// TODO Set the correct article ID here
const ARTICLE_ID = '20896017'

export function AppComponent() {
  const calendarsState = texts.reduce((a, b, i) => {
    return [...a, { state: 'max', count: 0 }]
  }, [])
  const cantonsDetails = require('./cantons.csv')
  const [scene, setScene] = useState(0)
  const [canvasData, setCanvasData] = useState(null)
  const [calendars, setCalendars] = useState(calendarsState)
  const [isOnCalendar, setIsOnCalendar] = useState(false)
  // const [cantonsData, setCantonsData] = useState([])
  // console.log(texts)
  // console.log(cantonsDetails)
  const cantonsData = require('./CH_cantonal_cases.csv')
  // console.log(cantonsData)
  history.scrollRestoration = 'manual'
  /* useEffect(() => {
    csv(
      'https://interactif.24heures.ch/ducDev/coronavirus_daily_cantonal/CH_cantonal_cases.csv'
    )
      .then(data => {
        console.log(data)
        setCantonsData(data)
      })
      .catch(error => {
        console.error(error)
      })
  }, []) */

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />
      <Canvas sceneId={scene} data={canvasData} isOnCalendar={isOnCalendar} />

      <div style={{ position: 'relative' }}>
        <header>
          <div className='ui container'>
            <h1 className='ui header'>Du premier cas à l’état d’urgence</h1>
            <h2 className='ui header'>
              <div className='small sub header'>
                Comment le nouveau coronavirus s’est-il propagé en Suisse?
                Retour chronologique sur l’irruption de la pandémie dans notre
                pays et sur les mesures prises par les autorités et ses
                conséquences.
              </div>
            </h2>
            <p className='ta author'>
              <strong>Yannick Van der Schueren et Mathieu Rudaz</strong>
            </p>
          </div>
        </header>

        {/* <Chart chartData={cantonsData} /> */}

        <div className='vertical segment'>
          {texts.map((day, sceneId) => {
            return day.texts.map((text, textId) => {
              const cantonDetails = cantonsDetails.find(
                c => c.canton === text.canton
              )
              const cantonName = cantonDetails
                ? cantonDetails.nameFr
                : text.canton

              const dateString =
                day.date.getFullYear() +
                '-' +
                String(day.date.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(day.date.getDate()).padStart(2, '0')
              const countryDay = cantonsData.find(c => c.date === dateString)
              const totalCount = countryDay ? +countryDay.CH : 0
              return (
                <>
                  {textId === 0 && (
                    <Waypoint
                      bottomOffset='95%'
                      key={`calendar-${sceneId}`}
                      onEnter={() => {
                        console.log('ENTER CALENDAR ' + sceneId)
                        const c = { ...calendars }
                        c[sceneId].state = 'min'
                        c[sceneId].count = totalCount
                        setCalendars(c)
                        setCanvasData(countryDay)
                        setIsOnCalendar(true)
                      }}
                      onLeave={() => {
                        console.log('LEAVE CALENDAR ' + sceneId)
                        const c = calendars
                        c[sceneId].state = 'max'
                        c[sceneId].count = 0
                        setCalendars(c)
                        setIsOnCalendar(false)
                      }}
                    >
                      <div
                        className={`calendar-scene ${calendars[sceneId].state}`}
                      >
                        <div className='calendar-scene-inner'>
                          <Calendar date={new Date(day.date)} />
                          <div className='calendar-cases'>
                            <Counter count={calendars[sceneId].count} />
                          </div>
                        </div>
                      </div>
                    </Waypoint>
                  )}
                  <Waypoint
                    bottomOffset='50%'
                    key={`scene${sceneId}-text${textId}`}
                    onEnter={() => {
                      console.log(`ENTER scene${sceneId}-text${textId}`)
                      setScene(`${sceneId}-${textId}`)
                    }}
                    onLeave={() => {
                      console.log(`LEAVE scene${sceneId}-text${textId}`)
                      if (sceneId === 10) {
                        console.log('unfix')
                      }
                    }}
                  >
                    <div className='scene'>
                      <div className='message ui text container'>
                        <div className='ui raised segment'>
                          <div className='message-bullet'>
                            <div />
                          </div>
                          <h5 className='header'>{cantonName}</h5>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: text.text
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </Waypoint>
                </>
              )
            })
          })}

          {/* <Controller> */}
          {/* <Scene
              indicators
              key={`scene${0}-calendar`}
              duration={600}
              triggerHook={0.1}
              pin
              classToggle='small'
            >
              <div className='calendar-scene'>
                <Calendar date={new Date('2020-03-12')} />
                <div className='calendar-cases'>
                  Premier cas
                </div>
              </div>
            </Scene>
            <Scene
              indicators
              triggerHook={0.5}
              duration='1000%'
            >
              {(progress, event) => {
                if (event.type) {
                  console.log(
                    `SCENE ${progress} - ${event.type} - ${Math.round(progress * 10)}`
                  )
                }

                return (<>
                  {texts.map((day, sceneId) => {
                    return (
                      day.texts.map((text, textId) => {
                        const cantonDetails = cantonsDetails.find(
                          c => c.canton === text.canton
                        )
                        const cantonName = cantonDetails
                          ? cantonDetails.nameFr
                          : text.canton

                        return (
                          <div
                            className='scene'
                            key={`scene${sceneId}-text${textId}`}
                          >
                            <div className='message ui text container'>
                              <div className='ui raised segment'>
                                <h5 className='header'>{cantonName}</h5>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: text.text
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                      )
                    })
                  )
                })}
                </>
              )}}
            </Scene> */}
          {/* texts.map((day, sceneId) => {
              const types = [1, 2]

              return types.map(t => {
                if (t === 1) {
                  const dateString =
                    day.date.getFullYear() +
                    '-' +
                    String(day.date.getMonth() + 1).padStart(2, '0') +
                    '-' +
                    String(day.date.getDate()).padStart(2, '0')
                  const countryDay = cantonsData.find(
                    c => c.date === dateString
                  )
                  const totalCount = countryDay ? countryDay.CH : 0
                  return (
                    <Scene
                      indicators
                      key={`scene${sceneId}-calendar`}
                      duration={600}
                      triggerHook={0.1}
                      pin
                      classToggle='small'
                    >
                      <div className='calendar-scene'>
                        <Calendar date={new Date(day.date)} />
                        <div className='calendar-cases'>
                          {sceneId === 0 ? (
                            'Premier cas'
                          ) : (
                            <Counter count={totalCount} />
                          )}
                        </div>
                      </div>
                    </Scene>
                  )
                } else {
                  return day.texts.map((text, textId) => {
                    const cantonDetails = cantonsDetails.find(
                      c => c.canton === text.canton
                    )
                    const cantonName = cantonDetails
                      ? cantonDetails.nameFr
                      : text.canton

                    return (
                      <Scene
                        key={`scene${sceneId}-text${textId}`}
                        indicators
                        triggerHook={0.5}
                        duration='100%'
                      >
                        {(progress, event) => {
                          if (event.type) {
                            console.log(
                              `SCENE ${sceneId}-${textId} - ${event.type}`
                            )
                            ;['start', 'end'].includes(event.type) &&
                              setScene(`${sceneId}-${textId}`)

                            if (
                              event.type === 'leave' &&
                              sceneId === 0 &&
                              textId === 0 &&
                              progress === 0
                            ) {
                              setScene('intro')
                            }
                          }

                          return (
                            <div className='scene'>
                              <div className='message ui text container'>
                                <div className='ui raised segment'>
                                  <h5 className='header'>{cantonName}</h5>
                                  <p
                                    dangerouslySetInnerHTML={{
                                      __html: text.text
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )
                        }}
                      </Scene>
                    )
                  })
                }
              })
            }) */}
          {/* </Controller> */}
        </div>
      </div>

      <div className='ui vertical grey segment' id='methode'>
        <div
          className='ui text container methodik'
          style={{ position: 'relative' }}
        >
          <div className='innerWrapperMethodik'>
            <h4>Méthodologie</h4>
            <p>
              Les données par canton proviennent des autorités cantonales
              officielles et non pas de l’Office fédéral de la santé publique
              (OFSP). Les chiffres quotidiens de l'OFSP n’ont pas été utilisés
              car ces derniers ne correspondent pas à ceux fournis par les
              Cantons en raison de leur retard dans la saisie des données. Pour
              cette raison, les chiffres cantonaux et pour la Suisse que nous
              présentons peuvent différer des pointages quotidiens de l’OFSP.
            </p>
            <p>
              Les données par canton proviennent de{' '}
              <a href='https://www.corona-data.ch/'>
                <i className='ui icon external alternate' />
                corona-data.ch
              </a>
              , qui récolte les données auprès de ces mêmes autorités mais de
              manière automatique.
            </p>
            <p>
              Les données ont ensuite été complétées par la Rédaction Tamédia
              pour donner une situation, par jour, la plus précise possible.
            </p>
          </div>
        </div>
      </div>

      {/* TODO Add your credits in this component */}
      <Footer
        locale='fr'
        hidePortfolioTeaser
        articleId={ARTICLE_ID}
        mailTo='mathieu.rudaz@24heures.ch'
        credits={[
          ['Textes', 'Yannick Van der Schueren'],
          ['Conception', 'Mathieu Rudaz']
        ]}
        questions={[
          'Ce contenu était-il informatif?',
          'La mise en oeuvre a-t-elle fonctionné?',
          'La mise en forme vous plaît-elle?'
        ]}
      />
    </div>
  )
}
